/* AZ Motorsport — sticky header + dropdown edge-detection.
   Moved verbatim out of the inline <script> in sections/header.liquid so it is fetched
   once and cached rather than re-parsed on every page load. It contained no Liquid at
   all, so nothing needed parameterising.

   Safe to `defer`: customElements.define() upgrades any <sticky-header> already in the
   document, and the trailing IIFE's own listeners are load/resize/shopify:section:load,
   all of which fire after a deferred script has run. */
 class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ;
    this.headerInner = this.header.querySelector('.header');
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 1069px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    window.addEventListener('resize', this.createObserver.bind(this));
  }

  setHeaderHeight() {
    const resizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${this.headerInner.offsetHeight}px`);
    });
    resizeObserver.observe(this.headerInner);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.createObserver.bind(this));
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
    }, { threshold: [0] });

    observer.observe(this.header);
  }

  onScroll() {
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.headerInner.classList.add('is-sticky');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.headerInner.classList.add('is-sticky');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.headerInner.classList.remove('is-sticky');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    });
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden');
    this.header.classList.add('shopify-section-header-sticky', 'animate');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('sticky-header', StickyHeader);

(function() {
window.addEventListener('load', function() {
  updateMenuPositions();
  document.addEventListener('shopify:section:load', function() {
    updateMenuPositions();
  });
});

window.addEventListener('resize', function() {
  updateMenuPositions();
});
document.addEventListener('shopify:section:load', function() {
  updateMenuPositions();
});
function updateMenuPositions() {
  const dropdownMenus = document.querySelectorAll('.list-menu li.list-menu__has-dropdown');
  dropdownMenus.forEach(menu => {
    const menuRect = menu.getBoundingClientRect();
    const menuRight = window.innerWidth - menuRect.right;
    if (menuRight < 450) {
      menu.classList.add('near-edge');
    } else {
      menu.classList.remove('near-edge');
    }
  });
}


const announcementHeader = document.querySelector('.shopify-section-group-header-group');
const announcementScrollingHeight = announcementHeader?.querySelector('.section-scrolling-text')?.clientHeight;

if (announcementScrollingHeight) {
  document.documentElement.style.setProperty('--announcement-scrolling-height', `${announcementScrollingHeight}px`);
}

})();

